/**
 * @generated SignedSource<<37db62ff816e946bb8bcb47cc72fc5dc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HubStatus = "OFFLINE" | "ONLINE" | "%future added value";
export type LockReservationFlow = "GOODS_RECEPTION" | "SWAP" | "%future added value";
export type myLocksListQuery$variables = {
  hubName: string;
  skipOwnedReservations: boolean;
};
export type myLocksListQuery$data = {
  readonly b2BLockReservations?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"MyLocksTabsOwnedFragment">;
    }>;
  };
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly status: HubStatus;
    };
    readonly id: string;
    readonly name: string;
  };
  readonly myUtilizationGrants: {
    readonly nodes: ReadonlyArray<{
      readonly reservation: {
        readonly flow: LockReservationFlow;
      };
      readonly " $fragmentSpreads": FragmentRefs<"MyLocksTabsFragment">;
    }>;
  };
};
export type myLocksListQuery = {
  response: myLocksListQuery$data;
  variables: myLocksListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipOwnedReservations"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "kind": "Literal",
  "name": "pagination",
  "value": {
    "page": 0,
    "pageSize": 1000
  }
},
v7 = [
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  },
  (v6/*:: as any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flow",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "flow": "SWAP",
      "subtype": "B2B"
    }
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      {
        "field": "STARTED_AT",
        "ordering": "DESC"
      }
    ]
  },
  (v6/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deactivatedAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentNote",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = [
  (v2/*:: as any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdByUserId",
      "plural": false,
      "selections": (v14/*:: as any*/),
      "storageKey": null
    }
  ],
  "type": "B2BlockReservationSubtype",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v14/*:: as any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rentalStartedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finalAmount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCollected",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v29 = {
  "alias": "lastUnlock",
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "status": "UNLOCKED"
      }
    },
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": [
        {
          "field": "CREATED_AT",
          "ordering": "DESC"
        }
      ]
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1
      }
    }
  ],
  "concreteType": "UnlockRequestPage",
  "kind": "LinkedField",
  "name": "unlockRequests",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnlockRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unlockedAt",
          "storageKey": null
        },
        (v28/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "unlockRequests(filter:{\"status\":\"UNLOCKED\"},orderBy:[{\"field\":\"CREATED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1})"
},
v30 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "String"
},
v31 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "DateTime"
},
v32 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "DateTime"
},
v33 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
},
v34 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UnlockRequestPage"
},
v35 = {
  "enumValues": null,
  "nullable": false,
  "plural": true,
  "type": "UnlockRequest"
},
v36 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Space"
},
v37 = {
  "enumValues": [
    "BACE_STOREFRONT_S",
    "BACE_STOREFRONT_M",
    "BACE_STOREFRONT_L",
    "BACE_STOREFRONT_XL",
    "BACE_STOREFRONT_2XL",
    "BACE_SATELLITE_SMALL_STANDARD",
    "BACE_SATELLITE_SMALL_SLIM",
    "BACE_SATELLITE_SMALL_EXTENDED",
    "BACE_SATELLITE_MEDIUM_STANDARD",
    "BACE_SATELLITE_MEDIUM_EXTENDED",
    "BACE_SATELLITE_LARGE_STANDARD",
    "BACE_SATELLITE_LARGE_EXTENDED",
    "BACE_CLATTERING_STANDARD",
    "BACE_TRUCK_HUB_STANDARD",
    "THALIA_RENZ_STANDARD_XS",
    "THALIA_RENZ_STANDARD_S",
    "THALIA_RENZ_STANDARD_M",
    "THALIA_RENZ_WIDE_S",
    "THALIA_RENZ_WIDE_M"
  ],
  "nullable": false,
  "plural": false,
  "type": "SpaceConfiguration"
},
v38 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v39 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Hub"
},
v40 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "HubMeta"
},
v41 = {
  "enumValues": [
    "INSTANT_BUY",
    "ONEDELIVERY",
    "CLICK_N_COLLECT",
    "RAFFLE",
    "LOCK_B2B",
    "LOCK_B2C",
    "SHOP_N_COLLECT"
  ],
  "nullable": false,
  "plural": true,
  "type": "HubService"
},
v42 = {
  "enumValues": [
    "ONLINE",
    "OFFLINE"
  ],
  "nullable": false,
  "plural": false,
  "type": "HubStatus"
},
v43 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Int"
},
v44 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "LockReservationSubtype"
},
v45 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "B2ClockSession"
},
v46 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "Int"
},
v47 = {
  "enumValues": null,
  "nullable": true,
  "plural": false,
  "type": "User"
},
v48 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "User"
},
v49 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "Float"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "myLocksListQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v5/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MyLocksTabsFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      {
        "condition": "skipOwnedReservations",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "b2BLockReservations",
            "args": (v9/*:: as any*/),
            "concreteType": "LockReservationPage",
            "kind": "LinkedField",
            "name": "lockReservations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MyLocksTabsOwnedFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "lockReservations(filter:{\"flow\":\"SWAP\",\"subtype\":\"B2B\"},orderBy:[{\"field\":\"STARTED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1000})"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "myLocksListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v5/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*:: as any*/),
        "concreteType": "UtilizationGrantPage",
        "kind": "LinkedField",
        "name": "myUtilizationGrants",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UtilizationGrant",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "reservation",
                "plural": false,
                "selections": [
                  (v8/*:: as any*/),
                  (v2/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "subtype",
                    "plural": false,
                    "selections": [
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "B2ClockSession",
                            "kind": "LinkedField",
                            "name": "b2CLockSession",
                            "plural": false,
                            "selections": [
                              (v17/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "currentCost",
                                "storageKey": null
                              },
                              (v18/*:: as any*/),
                              (v19/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "B2ClockReservationSubtype",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Hub",
                        "kind": "LinkedField",
                        "name": "hub",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HubMeta",
                            "kind": "LinkedField",
                            "name": "meta",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v22/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lat",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lng",
                                "storageKey": null
                              },
                              (v2/*:: as any*/),
                              (v23/*:: as any*/),
                              (v24/*:: as any*/),
                              (v25/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v26/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*:: as any*/),
                  (v28/*:: as any*/),
                  (v29/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/),
              (v10/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ty",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "permissions",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "myUtilizationGrants(input:{},pagination:{\"page\":0,\"pageSize\":1000})"
      },
      {
        "condition": "skipOwnedReservations",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "b2BLockReservations",
            "args": (v9/*:: as any*/),
            "concreteType": "LockReservationPage",
            "kind": "LinkedField",
            "name": "lockReservations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LockReservation",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  (v28/*:: as any*/),
                  (v27/*:: as any*/),
                  (v10/*:: as any*/),
                  (v11/*:: as any*/),
                  (v12/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "subtype",
                    "plural": false,
                    "selections": [
                      (v13/*:: as any*/),
                      (v15/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "B2ClockSession",
                            "kind": "LinkedField",
                            "name": "b2CLockSession",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v17/*:: as any*/),
                              (v4/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "paymentStatus",
                                "storageKey": null
                              },
                              (v18/*:: as any*/),
                              (v19/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "B2ClockSessionPayment",
                                "kind": "LinkedField",
                                "name": "activePayment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "amount",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "stripeStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "B2ClockReservationSubtype",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Hub",
                        "kind": "LinkedField",
                        "name": "hub",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v4/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HubMeta",
                            "kind": "LinkedField",
                            "name": "meta",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v3/*:: as any*/),
                              (v22/*:: as any*/),
                              (v23/*:: as any*/),
                              (v24/*:: as any*/),
                              (v25/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v26/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v29/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "lockReservations(filter:{\"flow\":\"SWAP\",\"subtype\":\"B2B\"},orderBy:[{\"field\":\"STARTED_AT\",\"ordering\":\"DESC\"}],pagination:{\"page\":0,\"pageSize\":1000})"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "82cc56a63b778ba8219f1400ee2937fb",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "b2BLockReservations": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationPage"
        },
        "b2BLockReservations.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "LockReservation"
        },
        "b2BLockReservations.nodes.contentNote": (v30/*:: as any*/),
        "b2BLockReservations.nodes.createdAt": (v31/*:: as any*/),
        "b2BLockReservations.nodes.deactivatedAt": (v32/*:: as any*/),
        "b2BLockReservations.nodes.id": (v33/*:: as any*/),
        "b2BLockReservations.nodes.lastUnlock": (v34/*:: as any*/),
        "b2BLockReservations.nodes.lastUnlock.nodes": (v35/*:: as any*/),
        "b2BLockReservations.nodes.lastUnlock.nodes.createdAt": (v31/*:: as any*/),
        "b2BLockReservations.nodes.lastUnlock.nodes.unlockedAt": (v32/*:: as any*/),
        "b2BLockReservations.nodes.note": (v30/*:: as any*/),
        "b2BLockReservations.nodes.space": (v36/*:: as any*/),
        "b2BLockReservations.nodes.space.configuration": (v37/*:: as any*/),
        "b2BLockReservations.nodes.space.frame": (v38/*:: as any*/),
        "b2BLockReservations.nodes.space.hub": (v39/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.id": (v33/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta": (v40/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta.city": (v38/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta.id": (v33/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta.name": (v38/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta.postalCode": (v38/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta.services": (v41/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.meta.street": (v38/*:: as any*/),
        "b2BLockReservations.nodes.space.hub.status": (v42/*:: as any*/),
        "b2BLockReservations.nodes.space.id": (v33/*:: as any*/),
        "b2BLockReservations.nodes.space.position": (v43/*:: as any*/),
        "b2BLockReservations.nodes.startedAt": (v31/*:: as any*/),
        "b2BLockReservations.nodes.subtype": (v44/*:: as any*/),
        "b2BLockReservations.nodes.subtype.__typename": (v38/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession": (v45/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession.activePayment": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPayment"
        },
        "b2BLockReservations.nodes.subtype.b2CLockSession.activePayment.amount": (v43/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession.activePayment.stripeStatus": {
          "enumValues": [
            "CANCELED",
            "PROCESSING",
            "REQUIRES_ACTION",
            "REQUIRES_CAPTURE",
            "REQUIRES_CONFIRMATION",
            "REQUIRES_PAYMENT_METHOD",
            "SUCCEEDED",
            "UNKNOWN"
          ],
          "nullable": true,
          "plural": false,
          "type": "StripePaymentIntentStatus"
        },
        "b2BLockReservations.nodes.subtype.b2CLockSession.amountCollected": (v43/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession.finalAmount": (v46/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession.id": (v33/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession.paymentStatus": {
          "enumValues": [
            "REQUIRES_CAPTURE",
            "REQUIRES_ACTION",
            "COMPLETED"
          ],
          "nullable": true,
          "plural": false,
          "type": "B2ClockSessionPaymentStatus"
        },
        "b2BLockReservations.nodes.subtype.b2CLockSession.rentalStartedAt": (v32/*:: as any*/),
        "b2BLockReservations.nodes.subtype.b2CLockSession.status": {
          "enumValues": [
            "AWAITING_PAYMENT",
            "RENTAL_STARTED",
            "RENTAL_ENDED",
            "CANCELLED"
          ],
          "nullable": false,
          "plural": false,
          "type": "B2ClockSessionStatus"
        },
        "b2BLockReservations.nodes.subtype.createdByUserId": (v47/*:: as any*/),
        "b2BLockReservations.nodes.subtype.createdByUserId.id": (v33/*:: as any*/),
        "b2BLockReservations.nodes.subtype.user": (v48/*:: as any*/),
        "b2BLockReservations.nodes.subtype.user.id": (v33/*:: as any*/),
        "hubMeta": (v40/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v33/*:: as any*/),
        "hubMeta.hub.status": (v42/*:: as any*/),
        "hubMeta.id": (v33/*:: as any*/),
        "hubMeta.name": (v38/*:: as any*/),
        "myUtilizationGrants": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrantPage"
        },
        "myUtilizationGrants.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrant"
        },
        "myUtilizationGrants.nodes.deactivatedAt": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "myUtilizationGrants.nodes.reservation": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservation"
        },
        "myUtilizationGrants.nodes.reservation.contentNote": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.createdAt": (v31/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.deactivatedAt": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.flow": {
          "enumValues": [
            "SWAP",
            "GOODS_RECEPTION"
          ],
          "nullable": false,
          "plural": false,
          "type": "LockReservationFlow"
        },
        "myUtilizationGrants.nodes.reservation.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock": (v34/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock.nodes": (v35/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock.nodes.createdAt": (v31/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.lastUnlock.nodes.unlockedAt": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.note": (v30/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space": (v36/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.configuration": (v37/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.frame": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub": (v39/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta": (v40/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.city": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.lat": (v49/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.lng": (v49/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.name": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.postalCode": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.services": (v41/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.meta.street": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.hub.status": (v42/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.space.position": (v43/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.startedAt": (v31/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype": (v44/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.__typename": (v38/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession": (v45/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.amountCollected": (v43/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.currentCost": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Decimal"
        },
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.finalAmount": (v46/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.b2CLockSession.rentalStartedAt": (v32/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId": (v47/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.createdByUserId.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.user": (v48/*:: as any*/),
        "myUtilizationGrants.nodes.reservation.subtype.user.id": (v33/*:: as any*/),
        "myUtilizationGrants.nodes.ty": {
          "enumValues": [
            "USER",
            "ORGANIZATION",
            "ANONYMOUS"
          ],
          "nullable": false,
          "plural": false,
          "type": "LockGrantType"
        }
      }
    },
    "name": "myLocksListQuery",
    "operationKind": "query",
    "text": "query myLocksListQuery(\n  $hubName: String!\n  $skipOwnedReservations: Boolean!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    hub {\n      id\n      status\n    }\n  }\n  myUtilizationGrants(input: {}, pagination: {page: 0, pageSize: 1000}) {\n    nodes {\n      reservation {\n        flow\n      }\n      ...MyLocksTabsFragment\n    }\n  }\n  b2BLockReservations: lockReservations(filter: {subtype: B2B, flow: SWAP}, orderBy: [{field: STARTED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1000}) @skip(if: $skipOwnedReservations) {\n    nodes {\n      id\n      ...MyLocksTabsOwnedFragment\n    }\n  }\n}\n\nfragment LockCardFragment on UtilizationGrant {\n  id\n  ty\n  permissions\n  deactivatedAt\n  reservation {\n    id\n    startedAt\n    createdAt\n    deactivatedAt\n    contentNote\n    note\n    lastUnlock: unlockRequests(filter: {status: UNLOCKED}, orderBy: [{field: CREATED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1}) {\n      nodes {\n        unlockedAt\n        createdAt\n      }\n    }\n    subtype {\n      __typename\n      ... on B2BlockReservationSubtype {\n        createdByUserId {\n          id\n        }\n      }\n      ... on B2ClockReservationSubtype {\n        user {\n          id\n        }\n        b2CLockSession {\n          rentalStartedAt\n          currentCost\n          finalAmount\n          amountCollected\n        }\n      }\n    }\n    space {\n      id\n      frame\n      position\n      configuration\n      hub {\n        id\n        status\n        meta {\n          id\n          name\n          services\n          street\n          city\n          postalCode\n        }\n      }\n    }\n  }\n}\n\nfragment MyLocksTabsFragment on UtilizationGrant {\n  id\n  deactivatedAt\n  reservation {\n    id\n    deactivatedAt\n    contentNote\n    note\n    subtype {\n      __typename\n      ... on B2BlockReservationSubtype {\n        createdByUserId {\n          id\n        }\n      }\n      ... on B2ClockReservationSubtype {\n        user {\n          id\n        }\n      }\n    }\n    space {\n      id\n      frame\n      position\n      hub {\n        id\n        meta {\n          name\n          services\n          lat\n          lng\n        }\n      }\n    }\n  }\n  ...LockCardFragment\n}\n\nfragment MyLocksTabsOwnedFragment on LockReservation {\n  id\n  createdAt\n  startedAt\n  deactivatedAt\n  contentNote\n  note\n  subtype {\n    __typename\n    ... on B2BlockReservationSubtype {\n      createdByUserId {\n        id\n      }\n    }\n    ... on B2ClockReservationSubtype {\n      user {\n        id\n      }\n    }\n  }\n  space {\n    id\n    frame\n    position\n    hub {\n      id\n    }\n  }\n  ...OwnedLockCardFragment\n}\n\nfragment OwnedLockCardFragment on LockReservation {\n  id\n  startedAt\n  createdAt\n  deactivatedAt\n  contentNote\n  note\n  lastUnlock: unlockRequests(filter: {status: UNLOCKED}, orderBy: [{field: CREATED_AT, ordering: DESC}], pagination: {page: 0, pageSize: 1}) {\n    nodes {\n      unlockedAt\n      createdAt\n    }\n  }\n  subtype {\n    __typename\n    ... on B2ClockReservationSubtype {\n      b2CLockSession {\n        id\n        rentalStartedAt\n        status\n        paymentStatus\n        finalAmount\n        amountCollected\n        activePayment {\n          amount\n          stripeStatus\n        }\n      }\n    }\n  }\n  space {\n    id\n    frame\n    position\n    configuration\n    hub {\n      id\n      status\n      meta {\n        id\n        name\n        services\n        street\n        city\n        postalCode\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba67297a04cfefa4ebbed7b33d069ea2";

export default node;
